import { useRouter } from "next/router";
import Link from "next/link";
import NextImage from "next/image";
import { useEffect, useState } from "react";
import axios from "axios";

import { Api } from "../../networks/Api";

const style_ico = {
  borderRadius: "5px",
};
const styl_ul = { listStyleType: "disc", marginLeft: "15px" };

const App = ({ t, queryParam }) => {
  const router = useRouter();
  const { locale } = router;
  const [branchData, setBranchData] = useState([]);
  const [open, setOpen] = useState(null);

  const toggle = (section) => {
    setOpen(open === section ? null : section);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        try {
          const res = await axios.get(Api.getBranch, Api.Header());
          setBranchData(res.data.data);
        } catch (error) {
          console.error("Error fetching getBranch:", error);
        }
      } catch (e) {
        console.error("Error in getBranch:", e);
      }
    };

    fetchData();
  }, []);

  const ClientService = () => {
    return (
      <ul
        className="flex flex-col gap-2 list-none p-0 m-0"
        style={{ listStyleType: "disc", marginLeft: "15px" }}
      >
        <li>
          <Link href={`/info/faq${queryParam ? `?${queryParam}` : ``}`}>
            <span className="text-black font-500">
              {t("terms-service-faq")}
            </span>
          </Link>
        </li>

        <li>
          <Link
            href={`/info/shipping-and-delivery${
              queryParam ? `?${queryParam}` : ``
            }`}
          >
            <span className="text-black font-500">
              {t("terms-service-shipping")}
            </span>
          </Link>
        </li>

        <li>
          <Link
            href={`/info/product-exchange-return-policy${
              queryParam ? `?${queryParam}` : ``
            }`}
          >
            <span className="text-black font-500">
              {t("terms-service-return")}
            </span>
          </Link>
        </li>

        <li>
          <Link href={`/info/size-chart${queryParam ? `?${queryParam}` : ``}`}>
            <span className="text-black font-500">{t("size-chart")}</span>
          </Link>
        </li>

        <li>
          <Link href={`/contact${queryParam ? `?${queryParam}` : ``}`}>
            <span className="text-black font-500">{t("contact")}</span>
          </Link>
        </li>
      </ul>
    );
  };

  const CompanyInformation = () => {
    return (
      <ul
        className="flex flex-col gap-2 list-none p-0 m-0"
        style={{ listStyleType: "disc", marginLeft: "15px" }}
      >
        <li>
          <Link
            href={`/info/terms-and-conditions${
              queryParam ? `?${queryParam}` : ``
            }`}
          >
            <span className="text-black font-500">
              {t("terms-service-condition")}
            </span>
          </Link>
        </li>

        <li>
          <Link
            href={`/info/privacy-policy${queryParam ? `?${queryParam}` : ``}`}
          >
            <span className="text-black font-500">
              {t("terms-service-privacy")}
            </span>
          </Link>
        </li>

        <li>
          <Link
            href={`/info/cookie-policy${queryParam ? `?${queryParam}` : ``}`}
          >
            <span className="text-black font-500">
              {t("terms-service-cookie")}
            </span>
          </Link>
        </li>

        <li>
          <Link href={`/about${queryParam ? `?${queryParam}` : ``}`}>
            <span className="text-black font-500">{t("about")}</span>
          </Link>
        </li>
      </ul>
    );
  };

  const StoreLocation = () => {
    return (
      <ul
        className="flex flex-col gap-2 list-none p-0 m-0"
        style={{ listStyleType: "disc", marginLeft: "15px" }}
      >
        {branchData?.map((branch) => (
          <li key={branch.id || branch.name_en}>
            <Link href={branch?.map_url || "https://www.google.com/maps"}>
              <span className="text-black font-500">
                {locale === "en"
                  ? branch?.name_en
                      ?.replace("Luxury29", "")
                      .trim()
                      .toUpperCase()
                  : branch?.name_th?.replace("ร้าน Luxury29 สาขา", "").trim()}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    );
  };

  return (
    <footer style={{ borderTop: "20px solid black" }}>
      <div className="mx-auto relative py-4 md:px-12">
        {/* <div className="footer-totop">
          <NextImage
            src={`/static/images/totop.png`}
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
            width={50}
            height={50}
            loading="lazy"
            alt="Image"
            unoptimized
          />
        </div> */}
        <div className="grid grid-cols-1  md:grid-cols-4 gap-4 justify-center px-5">
          <div className="py-5">
            <NextImage
              className="link"
              src="/static/images/logo.webp"
              alt="Image"
              width={200}
              height={32}
              unoptimized
            />
            <div className="flex flex-row gap-4 mt-1 px-2">
              <Link
                href={`https://www.instagram.com/luxury29th`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <NextImage
                  className="link"
                  style={style_ico}
                  src="/static/images/ico/ic_ig.webp"
                  alt="Image"
                  width={25}
                  height={25}
                  unoptimized
                />
              </Link>
              <Link
                href={`https://www.facebook.com/luxury29store`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <NextImage
                  className="link"
                  style={style_ico}
                  src="/static/images/ico/ic_fb.webp"
                  alt="Image"
                  width={25}
                  height={25}
                  unoptimized
                />
              </Link>
              <Link
                href={`https://lin.ee/hfscV5M`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <NextImage
                  className="link"
                  style={style_ico}
                  src="/static/images/ico/ic_line.webp"
                  alt="Image"
                  width={25}
                  height={25}
                  unoptimized
                />
              </Link>
              <Link
                href={`https://www.tiktok.com/@luxury29.official?_t=8fmZT9zpetu&_r=1`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <NextImage
                  className="link"
                  style={style_ico}
                  src="/static/images/ico/ic_tt.webp"
                  alt="Image"
                  width={25}
                  height={25}
                  unoptimized
                />
              </Link>
            </div>
            <p className="mt-1 px-2" style={{ fontSize: "12px" }}>
              Operation Time: MON - SUN 11:00 am - 10:00 pm
              <br />
              Email: contact@luxury29.io
              <br />
              Phone: +6680 265 1979
            </p>
          </div>

          {/* DESKTOP */}

          <div className="py-5 hidden md:block">
            <span className="h4">CLIENT SERVICE</span>
            <ClientService />
          </div>

          <div className="py-5 hidden md:block">
            <span className="h4">COMPANY INFORMATION</span>
            <CompanyInformation />
          </div>

          <div className="py-5 hidden md:block">
            <span className="h4">STORE LOCATION</span>
            <StoreLocation />
          </div>

          {/* MOBILE */}

          <div className="md:hidden mb-2">
            <div className="border-b py-4">
              <button
                className="w-full flex justify-between items-center"
                onClick={() => toggle("client")}
              >
                <span className="font-bold">CLIENT SERVICE</span>
                <span>{open === "client" ? "−" : "⌄"}</span>
              </button>

              {open === "client" && <ClientService />}
            </div>

            <div className="border-b py-4">
              <button
                className="w-full flex justify-between items-center"
                onClick={() => toggle("legal")}
              >
                <span className="font-bold">COMPANY INFORMATION</span>
                <span>{open === "legal" ? "−" : "⌄"}</span>
              </button>

              {open === "legal" && <CompanyInformation />}
            </div>

            <div className="border-b py-4">
              <button
                className="w-full flex justify-between items-center"
                onClick={() => toggle("store")}
              >
                <span className="font-bold">STORE LOCATION</span>
                <span>{open === "store" ? "−" : "⌄"}</span>
              </button>

              {open === "store" && <StoreLocation />}
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex justify-between mx-auto relative py-2 px-12"
        style={{ borderTop: "1px solid #D9D9D9" }}
      >
        <span style={{ color: "#A9A9A9" }}>
          © 2023 Luxury29. All Rights Reserved
        </span>
        <div>
          <div className="flex flex-row gap-2">
            <NextImage
              src="/static/images/ico/ic_visa.webp"
              width={35}
              height={35}
              alt="visa"
              unoptimized
            />
            <NextImage
              src="/static/images/ico/ic_mc.webp"
              width={35}
              height={35}
              alt="visa"
              unoptimized
            />
            {/* <NextImage
                src="/static/images/payment-jcb.webp"
                width={35}
                height={35}
                alt="visa"
                unoptimized
              /> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default App;
